import { render, staticRenderFns } from "./PcPcmRegnTap3Table1.vue?vue&type=template&id=17c7741d&"
import script from "./PcPcmRegnTap3Table1.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegnTap3Table1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports